import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UniversalLoginService } from '../services/universal-login.service';

export const authenticatedGuard: CanActivateFn = async () => {
  const authenticationService: AuthService = inject(AuthService);
  const universalLoginService = inject(UniversalLoginService);
  if (!authenticationService.isLoggedIn()) {
    universalLoginService.redirectToLogin(window.location.href);
  }

  return authenticationService.isLoggedIn();
};
